import { render } from "./PortfolioModal3.vue?vue&type=template&id=4c018609"
import script from "./PortfolioModal3.vue?vue&type=script&lang=js"
export * from "./PortfolioModal3.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__